
import { Investor, Contact } from "@/types/investor";
import { supabase } from "@/integrations/supabase/client";

/**
 * FULLY DEPRECATED - DO NOT USE
 * All database operations moved to databaseUtils.ts
 * These functions now do absolutely nothing and return empty values
 * Do NOT add any localStorage fallbacks here
 */

/**
 * DEPRECATED - DO NOT USE
 * All database operations moved to databaseUtils.ts
 */
export const saveProcessingProgress = async (
  investors: Investor[],
  contacts: Contact[],
  processedIds?: Set<string>
) => {
  console.warn("saveProcessingProgress is deprecated and does nothing - use database storage instead");
  return false;
};

/**
 * DEPRECATED - DO NOT USE
 * All database operations moved to databaseUtils.ts
 */
export const loadProcessingProgress = () => {
  console.warn("loadProcessingProgress is deprecated and does nothing - use database storage instead");
  return { 
    investors: [] as Investor[], 
    contacts: [] as Contact[], 
    processedIds: new Set<string>() 
  };
};

/**
 * DEPRECATED - DO NOT USE
 * All database operations moved to databaseUtils.ts
 */
export const clearProcessingProgress = () => {
  console.warn("clearProcessingProgress is deprecated and does nothing - use database storage instead");
  // Make sure we're not trying to access localStorage at all
  // No implementation - this function should do absolutely nothing
};
